<template>
    <div class="auth-page" id="auth-page">

        <app-loading 
            v-if="loading"
        />


        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            @clickMenu="change_menu(context, true)"
            @clickBack="clickBack"
        />

        <div class="auth-page__container">
            <div class="auth-page__title">
                Авторизация
            </div>
            <div class="auth-page__form">
                <phone-mask-input
                    v-model="phone"
                    defaultCountry="ru"
                    :autoDetectCountry="false"
                    :showFlag="false"
                    wrapperClass="wrraper-example"
                    inputClass="input-example"
                    flagClass="flag-example"
                    @onValidate="(payload) => auth_phone_validate(context, payload)"
                />
            </div>

            <div class="auth-page__personal-info">
                <div class="auth-page__personal-info-checkbox"
                    :class="{'auth-page__personal-info-checkbox-active' : checkbox}"
                    @click="checkbox = !checkbox"
                >
                    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="checkbox">
                        <path d="M14.8574 1.85742L5.42878 11.286L1.14307 7.00028" stroke="#31283D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="auth-page__personal-info-text">
                    Выражаю согласие на
                  <router-link to="/personal-data">
                    обработку персональных данных</router-link>,

                    <router-link to="/offer">Оферту</router-link>,

                    <router-link to="/return-policy">Правила заказа и возврата</router-link>
                </div>
            </div>

        </div>

        <div class="auth-page__button"
            @click="auth_phone_click_next(context, { redirect: '/auth/code' })"
            :class="{'auth-page__button-active' : statusButton}"
        >
            Далее
        </div>

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >

        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>

      <transition
          name="fade-overlay"
          appear
          mode="out-in"
      >

        <app-alert
            v-if="error.status"
            buttonText="ОК"
            :text="error.text"
            @clickGrowButtonPopup="() => {
              error.status = false
              overlay = false
              loading = false
            }"
        />

      </transition>

        
    </div>
</template>

<script>

    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const PhoneMaskInput = () => import('vue-phone-mask-input')
    const AppLoading = () => import('@/components/loading.vue')
    const AppAlert = () => import('@/components/popups/error')

    import change_menu from "@/views/theme/modules/change_menu";
    import auth_phone_validate from "@/views/auth/modules/auth_phone_validate";
    import auth_phone_get from "@/views/auth/modules/auth_phone_get";
    import auth_phone_click_next from "@/views/auth/modules/auth_phone_click_next";

    export default {
        data() {
            return {
                context: this,
                menu: false,
                overlay: false,
                checkbox: false,
                inputValidate: false,
                loading: false,
                phone: '',
                error: {
                  status: false,
                  text: ''
                }
            }
        },
        components: {
            AppHeader,
            AppMenu,
            AppOverlay,
            PhoneMaskInput,
            AppLoading,
            AppAlert
        },
        computed: {
            statusButton() {
              return (this.inputValidate && this.checkbox)
            },
            waitingPayment() {
              return this.$store.getters['settings/waitingPayment']
            }
        },
        methods: {
          change_menu,
          auth_phone_validate,
          auth_phone_get,
          auth_phone_click_next,
          clickBack() {
            window.history.back()
          }
        }
    }
</script>

<style lang="less">
    .auth-page {
        background-color: #2F1F4C;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        min-height: 273px;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .auth-page__container {
        width: 100%;
        height: 100%;
        padding-left: 17px;
        padding-right: 17px;
        margin-top: 32px;
        max-width: 380px;
    }

    .auth-page__title {
        color: #FFFFFF;
        font-size: 19px;
        line-height: 24px;
        font-family: 'Montserrat-Bold';
    }

    .auth-page__form {
        width: 100%;
        height: 40px;
        margin-top: 24px;
    }

    #auth-page .wrraper-example {
        width: 100%;
        height: 100%;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    #auth-page .auth-page__form input {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.15);
        border: none;
        outline: none;
        color: #B8B4C0;
        font-family: 'Roboto-Light';
        padding-left: 20px;
    }

    #auth-page .auth-page__form input::placeholder {
        color: #B8B4C0;
        font-family: 'Roboto-Light';
    }

    .auth-page__personal-info {
        width: 100%;
        display: flex;
        margin-top: 14px;
    }

    .auth-page__personal-info-checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        min-width: 24px;
        height: 24px;
        background-color:#464164;
        border-radius: 5px;
        cursor: pointer;
    }

    .auth-page__personal-info-checkbox-active {
        background-color: #fff;
    }

    .auth-page__personal-info-text {
        margin-left: 9px;
        color: #FFFFFF;
        line-height: 20px;
        font-size: 15px;
        font-family: 'Roboto-Light';
    }

    .auth-page__personal-info-text a {
        border-bottom: 1px dashed #FFFFFF;
        cursor: pointer;
        color: #FFFFFF;
        text-decoration: none;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .auth-page__button {
        width: 343px;
        height: 44px;
        border-radius: 5px;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #31283D;
        font-family: 'Montserrat-Medium';
        position: absolute;
        bottom: 10px;
        opacity: .3;
        transition-duration: .4s;
    }

    .auth-page__button-active {
        transition-duration: .4s;
        opacity: 1;
        cursor: pointer;
    }
</style>